<ul class="layout-tabmenu-nav">
    <li class="sidebar-group-clear">
        <span fxFlex="1 1 auto" *ngIf="selectedCurrency" [class]="flagIconClass(selectedCurrency)"></span>
    </li>
    <li class="sidebar-group">
        <mat-button-toggle-group *ngIf="currencies" #currencyToggleGroup="matButtonToggleGroup" (change)="onCurrencyChange($event)"
            [vertical]="true">
            <mat-button-toggle *ngFor="let currency of currencies" class="dashboardOptionSidebar" [value]="currency"
                [checked]="selectedCurrency === currency" [matTooltip]="'Switch to ' + currency"
                matTooltipPosition="right">
                <div fxLayout="column">
                    <!-- <span fxFlex="1 1 auto" [class]="flagIconClass(currency)"></span> -->
                    <span fxFlex="1 1 auto">{{currency}}</span>
                </div>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <li class="sidebar-group">
        <mat-button-toggle-group #ladderViewModeGroup="matButtonToggleGroup" (change)="onViewModeChange($event)"
            [vertical]="true">
            <mat-button-toggle *ngIf="profileType === 'ALM_MANAGER'" class="dashboardOptionSidebar" value="DASHBOARD" [checked]="viewMode == 'DASHBOARD'"
                matTooltip="Dashboard" matTooltipPosition="right">
                <mat-icon>dashboard</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="profileType === 'ALM_TRADER'" class="dashboardOptionSidebar" value="LADDER" [checked]="viewMode == 'LADDER'"
                matTooltip="Ladders" matTooltipPosition="right">
                <mat-icon>format_indent_increase</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="profileType === 'ALM_TRADER'" class="dashboardOptionSidebar" value="REPORT" [checked]="viewMode == 'REPORT'"
                matTooltip="Reports" matTooltipPosition="right">
                <mat-icon>format_list_numbered_rtl</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="profileType === 'ALM_MANAGER' || profileType === 'ALM_TRADER'" class="dashboardOptionSidebar" value="SIMULATION" [checked]="viewMode == 'SIMULATION'"
                matTooltip="Simulation" matTooltipPosition="right">
                <mat-icon>model_training</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <li class="sidebar-group">
        <mat-button-toggle-group #batchToggleGroup="matButtonToggleGroup" (change)="onBatchChange($event)"
            [vertical]="true">
            <mat-button-toggle *ngFor="let batch of batches" class="dashboardOptionSidebar" [value]="batch"
                [checked]="selectedBatch === batch"
                [matTooltip]="'Switch to ' + batch.organizationName+':'+ batch.identifier+' on '+batch.date"
                matTooltipPosition="right">
                <div fxLayout="column">
                    <!-- <span fxFlex="1 1 auto" [class]="flagIconClass(currency)"></span> -->
                    <span class="batch-name" fxFlex="1 1 10%">{{batch.organizationName}}</span>
                    <span class="batch-identifier" fxFlex="1 1 80%">{{batch.identifier}}</span>
                    <span class="batch-name" fxFlex="1 1 10%">{{batch.date}}</span>
                </div>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <!-- <li class="sidebar-group-clear">
        <button mat-icon-button class="action-button" (click)="openDisplayCurveDialog($event)" matTooltip="Show Curves"
            matTooltipPosition="right">
            <mat-icon>show_chart</mat-icon>
        </button>
    </li> -->
</ul>